import React, { createContext, useContext, useEffect, useState } from "react";

const FavouritesContext = createContext();

export const FavouritesProvider = ({ children }) => {
  const [favs, setFavs] = useState(() => {
    if (typeof window !== "undefined") {
      try { return JSON.parse(localStorage.getItem("lp-favs") || "[]"); }
      catch { return []; }
    }
    return [];
  });

  useEffect(() => {
    localStorage.setItem("lp-favs", JSON.stringify(favs));
  }, [favs]);

  const toggleFav = (id) =>
    setFavs((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  const isFav = (id) => favs.includes(id);
  // A favourited deal that has expired or been taken down should stop counting on the badge.
  const pruneFavs = (liveIds) =>
    setFavs((prev) => (prev.every((id) => liveIds.includes(id)) ? prev : prev.filter((id) => liveIds.includes(id))));

  return (
    <FavouritesContext.Provider value={{ favs, toggleFav, isFav, pruneFavs }}>
      {children}
    </FavouritesContext.Provider>
  );
};

export const useFavourites = () => useContext(FavouritesContext);
